import { ReactElement } from 'react'
import FormCollapsibleSection from './FormCollapsibleSection'
import { CollapsibleBoxSectionProps } from './collapsibleSectionProps'
import { FormSectionIcons } from './icons'

interface Props extends CollapsibleBoxSectionProps {
  label?: string
}

const CollapsibleOpeningsBoxSection = ({
  children,
  label = 'Öffnungen',
  defaultExpanded = false,
  dataCy,
  isEmpty,
}: Props): ReactElement | null => {
  return (
    <FormCollapsibleSection
      label={label}
      startIcon={FormSectionIcons.openings}
      defaultExpanded={defaultExpanded}
      dataCy={dataCy}
      isEmpty={isEmpty}
    >
      {children}
    </FormCollapsibleSection>
  )
}

export default CollapsibleOpeningsBoxSection
